import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import portedOutPlatformNumber from 'API/PlatformNumber/portedOutPlatformNumber';

const useTransferOutPlatformNumbers = (numbers, scope, refetch) => {
    return useMutation({
        mutationFn: async () => {
            let allSuccessful = true;

            for (const number of numbers) {
                try {
                    await portedOutPlatformNumber(
                        number.numberID,
                        number.platformID,
                        scope,
                    );
                } catch (error) {
                    allSuccessful = false;
                    toast.error(
                        `Failed to transfer out +${number.telephoneNumber}: ${
                            error?.response?.data?.message ||
                            'Please try again later.'
                        }`,
                    );
                }
            }

            refetch?.();
            if (!allSuccessful) {
                throw new Error('Failed to transfer out some numbers');
            }
            toast.success('Numbers transferred out successfully!');
        },
    });
};

export default useTransferOutPlatformNumbers;
